/**
 * A storage class which emulates[1] Storage (i.e. localStorage). You can use it almost the same way as
 * localStorage or sessionStorage, with a few exceptions (see: key). It is meant to be used
 * as a stub when localStorage, sessionStorage & cookies are unavailable --in a server side rendered environment, for example.
 *
 * [1] - This class does not extend Storage, because when localStorage is disabled, calling super() on Storage will cause a fatal error (i.e. Illegal constructor)
 *
 * @hidden
 * @class MemoryStorage
 */

export default class MemoryStorage {
  _memoryStorage: any = {};

  length() {
    return Object.keys(this._memoryStorage).length;
  }

  getItem(key: string): any {
    return this._memoryStorage[key];
  }

  setItem(key: string, data: any) {
    if (!key) {
      return;
    }
    this._memoryStorage[key] = data;
    return data;
  }

  removeItem(key: string) {
    if (!key || !this._memoryStorage[key]) {
      return;
    }
    this._memoryStorage[key] = undefined;
  }

  clear() {
    this._memoryStorage = {};
  }

  key(_: number) {
    console.warn('[ArcId] unsupported method, please use getItem(key) instead.');
    return 'N/A';
  }
}
